export class resourcesService {

    constructor($resource, ApiService, Upload, $cookies, DateService, Constants) {
        'ngInject';

        this.$resource = $resource;
        this.$cookies = $cookies;
        this.apiService = ApiService;
        this.upload = Upload;
        this.dateService = DateService;
        this.constants = Constants;

        this.resourcesDetailsResourceUrl = this.apiService.getResourceUrl('/resource');
        this.resourcesDetailsResource = this.$resource(this.resourcesDetailsResourceUrl);
        this.resourceSlugUrl = this.apiService.getResourceUrl('/resource/:slug');
        this.resourcesSubCategoryDetailsUrl = this.apiService.getResourceUrl('/resource/:slug/:id');

        this.resourceSlugResource = this.$resource(this.resourceSlugUrl, null, {
            update: {
                method: 'PUT'
            }
        });

        this.resourcesSubCategoryDetails = this.$resource(this.resourcesSubCategoryDetailsUrl, null, {
            update: {
                method: 'PUT'
            }
        })

    }
    getResourcesDetails() {
        const promise = this.resourcesDetailsResource.get().$promise;
        return promise.then((details) => this._getResourcesObjectList(details.details.resourceList));
    }

    _getResourcesObjectList(list) {
        return list.map(value => this._getResoureceObject(value));
    }

    getResourcesCategoryDetailsById(slug) {
        const promise = this.resourceSlugResource.get({
            slug: slug
        }).$promise;
        return promise
            .then(details => this._getResourcesrCategoryListObject(details.details))
            .catch(error => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    _getResourcesrCategoryListObject(categoryList) {
        let details = {
            categoryDetails: categoryList.categoryDetails,
            categoryList: categoryList.categoryResourceList.map(category => this._getResourcerCategoryObject(category))
        }
        return details
    }

    _getResourcerCategoryObject(category) {
        let categoryObject = {
            category: category.category,
            id: category.categoryResourceMappingId,
            name: category.displayName,
            url: category.url,
            downloadUrl: category.url

        };
        return categoryObject;
    }

    _getResoureceObject(details) {
        return {
            id: details.categoryId,
            name: details.displayName,
            count: details.count,
            sortOrder: details.sortOrder,
            icon: details.iconPath,
            slug: details.slug
        }
    }

    addResourceCategory(details, slug) {
        const promise = this.resourceSlugResource.save({
            slug: slug
        }, details).$promise;
        return promise.then(({ data }) => data).catch((error) => {
            throw this.apiService.getErrorMessage(error);
        });
    }

    _setCategoryObject(categoryDetails) {
        if (categoryDetails.resourceName === "Directory") {
            const categoryObject = {
                name: categoryDetails.name,
                resource_id: categoryDetails.resourceId,
                content: this._getSubCategoryContentDetails(categoryDetails.subCategoryList)
            }
            return categoryObject;
        } else {
            const categoryObject = {
                name: categoryDetails.name,
                resource_id: categoryDetails.resourceId,
                content: this._getOtherResourceSubCategoryContentDetails(categoryDetails)
            }
            return categoryObject;
        }

    }

    _getOtherResourceSubCategoryContentDetails(contentDetails) {
        let details = {};
        if (contentDetails.hasOwnProperty('pdf') && contentDetails.pdf) {
            details.pdf = contentDetails.pdf;
        }
        if (contentDetails.hasOwnProperty('image') && contentDetails.image) {
            details.image = contentDetails.image;
        }
        if (contentDetails.file && contentDetails.file.hasOwnProperty('link')) {
            details.link = contentDetails.file.link;
        }
        return details;
    }

    _getSubCategoryContentDetails(subCategoryList) {
        return subCategoryList.map(subCategory => {
            let subCategoryObject = {
                name: subCategory.name,
                address: this._getAddressObject(subCategory.address),
                phone: this._getPhoneNumberObject(subCategory.phoneNumbers)
            }
            return subCategoryObject;
        });

    }

    _getAddressObject(addressList) {
        return addressList.map(address => {
            let addressObject = {
                latitude: address.lat,
                zip_code: address.zipCode,
                city_name: address.cityName,
                longitude: address.lng,
                state_code: address.stateCode,
                state_name: address.stateName,
                address_line_1: address.addressLine1,
                address_line_2: address.addressLine2
            }
            return addressObject;
        })
    }

    deleteCategory(slug, id) {
        const promise = this.resourcesSubCategoryDetails.delete({
            id,
            slug
        }).$promise;
        return promise
            .then((response) => response);

    }

    _getPhoneNumberObject(phoneNumberList) {
        return phoneNumberList.map(details => {
            let contact = {
                number: details.value,
                ext: details.ext
            }
            return contact;
        })
    }

    getResourceVideoUrl(slug) {
        const promise = this.resourceSlugResource.get({ slug }).$promise;
        return promise
            .then(details => details.details)
            .catch(error => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    updateResourceVideoUrl(slug, details) {
        const promise = this.resourceSlugResource.update({ slug }, details).$promise;
        return promise.then((response) => response)
            .catch((error) => {
                console.log("error", error);
            });
    }

    getResourcesSubCategoryDetailsById(id, slug) {
        const promise = this.resourcesSubCategoryDetails.get({
            id,
            slug
        }
        ).$promise;

        return promise
            .then(details => this._getResourcesSubCategoryListObject(details.details.categoryResourceDetails))
            .catch(error => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    _getResourcesSubCategoryListObject(data) {
        const subCategoryListObject = {
            id: data.categoryResourceMappingId,
            name: data.displayName,
            categoryId: data.categoryId,
            link: data.url
        }
        return subCategoryListObject;

    }

    updateSubCategory(details, slug, id) {
        const promise = this.resourcesSubCategoryDetails.update({ slug, id }, details).$promise;
        return promise.then(({ details }) => {
            return (details);
        }).catch((error) => {
            throw this.apiService.getErrorMessage(error);
        });
    }

    _getSubCategoryPhoneNumber(phoneList) {
        return phoneList.map(phone => {
            const number = {
                value: phone.number,
                ext: phone.ext
            }
            return number;
        });

    }

    getCategoryOption() {
        return [
            {
                id: this.constants.RESOURCE.CATEGORY_OPTION.WEB_LINK,
                name: "option 1",
                title: "web link",
                value: "1",
                disabled: false,
                selected: true
            },
            {
                id: this.constants.RESOURCE.CATEGORY_OPTION.ATTACHMENT,
                name: "option 2",
                title: "attachment",
                value: "1",
                disabled: false,
                selected: false
            }
        ]
    }

}


// WEBPACK FOOTER //
// ./src/app/components/resources/resources.service.js